export default __webpack_public_path__ + "static/media/logo.41f02e2c.svg";